import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import StrapiHtml from '@templates/strapi-cms/content-types/HTML'

export const HTML = data => <StrapiHtml data={data} />

const BunkieQuery = () => (
  <StaticQuery
    query={graphql`
      query ASTMLegalCopy {
        strapiHtml(Title: { eq: "HTML - ASTM Legal Copy - Bunkie Board Product Description" }) {
          ...StrapiHtmlFragment
        }
      }
    `}
    render={data => HTML(data.strapiHtml)}
  />
)
export default BunkieQuery
